module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dropdown', {
    attrs: {
      "disabled": _vm.disabled,
      "dropup": _vm.dropup,
      "text": _vm.buttonText,
      "variant": _vm.buttonType,
      "right": _vm.right,
      "size": _vm.size
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.$emit('confirmed')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32f461f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmButton.vue
// module id = 1313
// module chunks = 16